export default {
    "language": "Язык",
    "title": "Кабинет",
}
